// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import addDays from "@insite/client-framework/Common/Utilities/addDays";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { CartLineContext } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import siteMessage from "@insite/client-framework/SiteMessage";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import {
    Button,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
} from "@insite/mobius/index";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import ArrowiOSUpward from "@store/Library/Components/Toolkit/Icons/ArrowiOSUpward";
import Checkmark from "@store/Library/Components/Toolkit/Icons/Checkmark";
import CopyFill from "@store/Library/Components/Toolkit/Icons/Copy/CopyFill";
import EditFill from "@store/Library/Components/Toolkit/Icons/Edit/EditFill";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import Truck from "@store/Library/Components/Icons/Truck";
import TextField, { TextFieldPresentationProps } from "@store/MobiusOverrides/TextField/TextField";
import Typography from "@store/MobiusOverrides/Typography/Typography";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import getDaysDifference from "@store/Framework/Common/Utilities/getDaysDifference";
import setCopiedRequestedDateRow from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/SetCopiedRequestedDateRow";
import setIsEditingDate from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/UpdateIsEditingDates";
import ProductFullTruckLoad, {
    ProductFullTruckLoadPresentationProps,
} from "@store/Library/Components/ProductFullTruckLoad";
import ProductLeadTime, { ProductLeadTimePresentationProps } from "@store/Library/Components/ProductLeadTime";
import Status, { StatusProps } from "@store/Library/Components/Status";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@store/MobiusOverrides/DatePicker/DatePicker";
import CartLineQuantity, { CartLineQuantityPresentationProps } from "@store/Overrides/Widgets/Cart/CartLineQuantity";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { tableProps } from "@store/Themes/common/props/table";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext, useEffect, useMemo, useRef, useState, Fragment } from "react";
import { css } from "styled-components";
import LocalizedDateTime from "@store/Overrides/Components/LocalizedDateTime";
import tryJsonParse from "@store/Framework/Common/Utilities/tryJsonParse";
import { convertUTCDateToLocalDate } from "@store/Framework/Common/Utilities/convertUTCDateToLocalDate";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { useCurrentLanguage, useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import ProductLineQuantity, {
    ProductLineQuantityPresentationProps,
} from "@store/Library/Components/ProductLine/ProductLineQuantity";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import ClipboardFill from "@store/Library/Components/Icons/Clipboard/ClipboardFill";

const tableHeaderSeparatorStyles = (marginRight?: string) => {
    return css`
        &::before {
            content: "";
            display: block;
            width: ${pxToRem(1)};
            height: 1em;
            background-color: ${getColor("common.borderLight")};
            ${cssProp("margin-right", marginRight)}
        }
    `;
};

// Warning outline applied to a requested-date QTY field when its quantity is below the product's MOQ.
const warningBorderCss = css`
    &,
    &:focus {
        border-color: ${getColor("warning.main")};
    }
`;

export interface CartLinesDatesPresentationProps extends ExpandStyles<CartLinesDatesStyles> {}

export interface CartLinesDatesProps extends CartLinesDatesPresentationProps {
    cart?: Cart;
    deliveryDatesUpdatedHandler?: (deliveryDates: CartLinesDeliveryDate[]) => void;
    isProductLine?: boolean;
    enableCopyPaste?: boolean;
}

export interface CartLinesDatesStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    actionsWrapper?: InjectableCss;
    leftActionsWrapper?: InjectableCss;
    rightActionsWrapper?: InjectableCss;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    quantityTableHeader?: DataTableHeaderProps;
    quantityTableCell?: DataTableCellProps;
    dateTableHeader?: DataTableHeaderProps;
    dateTableCell?: DataTableCellProps;
    poTableHeader?: DataTableHeaderProps;
    poTableCell?: DataTableCellProps;
    poTextField?: TextFieldPresentationProps;
    actionsTableHeader?: DataTableHeaderProps;
    actionsTableCell?: DataTableCellProps;
    errorTableCell?: DataTableCellProps;
    belowMoqTableCell?: DataTableCellProps;
    belowMoqInfosBox?: InfosBoxProps;
    belowMoqProductLineQuantity?: ProductLineQuantityPresentationProps;
    belowMoqCartLineQuantity?: CartLineQuantityPresentationProps;
    status?: StatusProps;
    datePicker?: DatePickerPresentationProps;
    linkEdit?: LinkPresentationProps;
    buttonSave?: ButtonPresentationProps;
    buttonCancel?: ButtonPresentationProps;
    buttonEdit?: ButtonPresentationProps;
    linkDelete?: LinkPresentationProps;
    linkAdd?: LinkPresentationProps;
    productFullTruckLoad?: ProductFullTruckLoadPresentationProps;
    productLeadTime?: ProductLeadTimePresentationProps;
    tableHeaderWrapper?: InjectableCss;
    collapseLink?: LinkPresentationProps;
    expandLink?: LinkPresentationProps;
    copyPasteTableCell?: DataTableCellProps;
    copyPasteWrapper?: InjectableCss;
    linkCopy?: LinkPresentationProps;
    linkPaste?: LinkPresentationProps;
    linkPasteDisabled?: LinkPresentationProps;
    copyPasteConfirmation?: InjectableCss;
    confirmationIcon?: IconPresentationProps;
}

export const cartLinesDatesStyles: CartLinesDatesStyles = {
    wrapper: productLineProps.requestedDatesWrapper,
    innerWrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
            padding: ${pxToRem(16)};
            ${breakpoint("md", "down")} {
                overflow-x: auto;
            }
        `,
    },
    collapseLink: linkGetActionLinkProps(ArrowiOSUpward, "right"),
    expandLink: linkGetActionLinkProps(ArrowiOSDownward, "right"),
    tableWrapper: tableProps.wrapper,
    dataTable: {
        mergeCss: true,
        css: css`
            tr.error > td {
                border-bottom: 0;
            }
            tr.below-moq > td {
                border-bottom: 0;
            }
            tr.has-actions > td {
                border-bottom: 0;
            }
            tr.has-messages > td {
                border-bottom: 0;
            }
        `,
    },
    tableHeaderWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: ${pxToRem(0, 6)};
        `,
    },
    quantityTableHeader: {
        css: css`
            width: 20%;
        `,
    },
    productFullTruckLoad: {
        displayTexts: false,
        displayIcons: true,
        extendedStyles: {
            ftlWrapper: {
                css: css`
                    ${tableHeaderSeparatorStyles(pxToRem(2))}
                `,
            },
            fullTruckLoadMessage: {
                tooltip: {
                    useOverlay: true,
                },
            },
            ftlIcon: {
                useOverlay: true,
            },
        },
    },
    dateTableHeader: {
        css: css`
            width: 40%;
            min-width: ${pxToRem(220)};
        `,
    },
    productLeadTime: {
        displayLabel: false,
        showShortLeadTimeDesc: true,
        displayAsStatus: false,
        extendedStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    align-items: center;
                    ${tableHeaderSeparatorStyles(pxToRem(6))}
                `,
            },
            leadTimeMessage: {
                tooltip: {
                    useOverlay: true,
                },
            },
            calendarTooltipProps: {
                useOverlay: true,
            },
        },
    },
    poTableHeader: {
        css: css`
            width: 40%;
            min-width: ${pxToRem(220)};
        `,
    },
    actionsTableHeader: mergeProps<CartLinesDatesStyles["actionsTableHeader"]>(tableProps.tightHeader, {
        css: css`
            padding-left: 0;
        `,
    }),
    actionsTableCell: mergeProps<CartLinesDatesStyles["actionsTableCell"]>(tableProps.tightCell, {
        css: css`
            padding-left: 0;
        `,
    }),
    errorTableCell: {
        css: css`
            padding-top: 0;
            border-top: 0;
        `,
    },
    belowMoqTableCell: {
        css: css`
            padding-top: 0;
            border-top: 0;
        `,
    },
    belowMoqInfosBox: {
        type: "warning",
        size: "small",
        extendedStyles: {
            icon: { src: Truck },
        },
    },
    belowMoqProductLineQuantity: {
        extendedStyles: {
            textField: { cssOverrides: { inputSelect: warningBorderCss } },
        },
    },
    belowMoqCartLineQuantity: {
        extendedStyles: {
            editableQuantityTextField: { cssOverrides: { inputSelect: warningBorderCss } },
        },
    },
    datePicker: {
        useOverlay: true,
    },
    status: {
        type: "red",
        showIcon: true,
        extendedStyles: {
            wrapper: {
                css: css`
                    display: inline-flex;
                    width: auto;
                `,
            },
        },
    },
    actionsWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: ${pxToRem(24)};
            margin-top: ${pxToRem(12)};
        `,
    },
    leftActionsWrapper: {
        css: css`
            flex-grow: 999;
        `,
    },
    rightActionsWrapper: {
        css: css`
            display: flex;
            flex-grow: 1;
            flex-wrap: wrap;
            justify-content: flex-end;
            gap: ${pxToRem(10)};

            &:first-child {
                flex-grow: unset;
                margin-left: auto;
            }

            ${breakpoint("xs", "down")} {
                width: 100%;
            }
        `,
    },
    buttonSave: {
        variant: "primary",
        sizeVariant: "small",
        mergeCss: true,
        css: css`
            flex-grow: 1;
        `,
    },
    buttonCancel: {
        variant: "tertiary",
        sizeVariant: "small",
        mergeCss: true,
        css: css`
            flex-grow: 1;
        `,
    },
    buttonEdit: {
        variant: "primary",
        sizeVariant: "small",
        icon: {
            position: "left",
            src: EditFill,
        },
        mergeCss: true,
        css: css`
            flex-grow: 1;
        `,
    },
    linkEdit: linkGetActionLinkProps(EditFill),
    linkDelete: linkGetActionLinkProps(TrashFill),
    linkAdd: linkGetActionLinkProps(PlusCircleFill),
    copyPasteTableCell: {
        css: css`
            padding-top: ${pxToRem(4)};
            border-top: 0;
        `,
    },
    copyPasteWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: ${pxToRem(24)};
        `,
    },
    linkCopy: linkGetActionLinkProps(CopyFill),
    linkPaste: linkGetActionLinkProps(ClipboardFill),
    linkPasteDisabled: mergeProps<CartLinesDatesStyles["linkPasteDisabled"]>(linkGetActionLinkProps(ClipboardFill), {
        color: "text.disabled",
        css: css`
            color: ${getColor("text.disabled")};

            &:hover {
                color: ${getColor("text.disabled")};
            }
        `,
    }),
    copyPasteConfirmation: {
        css: css`
            display: inline-flex;
            align-items: center;
            gap: ${pxToRem(6)};
            color: ${getColor("success.main")};
            font-weight: ${x => x.theme.design.typography.weight.semibold};
        `,
    },
    confirmationIcon: {
        src: Checkmark,
        color: "inherit",
        size: 16,
    },
};

export interface CartLinesDeliveryDate {
    id: string;
    quantity: number | string;
    requestedDate: Date | undefined;
    customerOrderPO: string;
    notes: string;
    error?: {
        quantity?: string;
        requestedDate?: string;
        po?: string;
    };
}

const today = new Date();

const COPY_PASTE_CONFIRMATION_DURATION_MS = 2000;

const CartLinesDates: FC<CartLinesDatesProps> = ({
    cart,
    deliveryDatesUpdatedHandler = () => {},
    extendedStyles,
    isProductLine,
    overridedStyles,
    enableCopyPaste,
}) => {
    const dispatch = useAppDispatch();
    const { cartSettings } = useSettingsCollection();
    const language = useCurrentLanguage();
    const cartLine = useContext(CartLineContext);
    const styles = useExpandProps(cartLinesDatesStyles, extendedStyles, overridedStyles);
    const minimumOrderQuantity = Number(cartLine?.pricing?.additionalResults?.minimumOrderQuantity ?? 0);

    const [showDatesTable, setShowDatesTable] = useState(true);
    const [deliveryDates, setDeliveryDates] = useState<CartLinesDeliveryDate[]>([]);
    const [savedDeliveryDates, setSavedDeliveryDates] = useState<CartLinesDeliveryDate[]>([]);
    const [isEditingDates, setIsEditingDates] = useState(true);

    const copiedRow = useAppSelector(state => state.greif.pages.cart.requestedDate.copiedRow);
    const [copiedIndicatorId, setCopiedIndicatorId] = useState<string | undefined>(undefined);
    const [pastedIndicatorId, setPastedIndicatorId] = useState<string | undefined>(undefined);
    const copiedTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    const pastedTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    // Per-row counter bumped on paste, used in the DatePicker key to force it to remount and re-read the pasted
    // value. The DatePicker keeps its displayed value in internal state and does not reliably re-render an empty
    // value pushed in through props, so pasting an empty Requested Date would otherwise leave the old date showing.
    const datePasteVersionRef = useRef<Record<string, number>>({});

    const parsedDeliveryDates = useMemo(() => {
        const defaultValues: CartLinesDeliveryDate[] = [
            {
                id: uniqueId(),
                quantity: cartLine?.qtyOrdered ?? 1,
                requestedDate: undefined,
                notes: "",
                customerOrderPO: "",
            },
        ];

        const parsed = cartLine?.properties.deliveryDates
            ? (tryJsonParse<CartLinesDeliveryDate[]>(cartLine.properties.deliveryDates) ?? defaultValues)
            : defaultValues;

        // Restore local datetime from UTC date time.
        // This needs to be treated as a simple date, not a point in time, so we need to ignore timezone offsets.
        parsed.forEach(d => {
            if (d.requestedDate) {
                d.requestedDate = convertUTCDateToLocalDate(d.requestedDate);
            }
        });

        return parsed;
    }, [cartLine?.properties.deliveryDates]);

    useEffect(() => {
        const isMissingDate = parsedDeliveryDates.some((l: CartLinesDeliveryDate) => !l.requestedDate);
        const isMissingPO = parsedDeliveryDates.some((l: CartLinesDeliveryDate) => !l.customerOrderPO);
        const hasPastDate = parsedDeliveryDates.some(
            (l: CartLinesDeliveryDate) => getDaysDifference(new Date(l.requestedDate!), today) < 0,
        );

        setDeliveryDates(parsedDeliveryDates);

        if (hasPastDate && parsedDeliveryDates.length > 0) {
            const _tempDeliveryDates = parsedDeliveryDates.map(d =>
                d.requestedDate && getDaysDifference(new Date(d.requestedDate), today) < 0
                    ? {
                          ...d,
                          error: {
                              requestedDate: translate(
                                  "{0} is no longer valid. Please define a new date.",
                                  getLocalizedDateTime({ dateTime: new Date(d.requestedDate as Date), language }) ||
                                      translate("Date"),
                              ),
                              quantity: "",
                              po: "",
                          },
                      }
                    : d,
            );
            setDeliveryDates(_tempDeliveryDates);
            return;
        }

        if (!isMissingDate && !isMissingPO) {
            dispatch(setIsEditingDate({ isEditingDate: false }));
            setIsEditingDates(false);
        } else {
            dispatch(setIsEditingDate({ isEditingDate: true }));
            setIsEditingDates(true);
        }
    }, [parsedDeliveryDates]);

    useEffect(() => {
        const isMissingDate = deliveryDates.some((l: CartLinesDeliveryDate) => !l.requestedDate);
        const isMissingPO = deliveryDates.some((l: CartLinesDeliveryDate) => !l.customerOrderPO);

        if ((isMissingDate || isMissingPO) && !isEditingDates) {
            setIsEditingDates(true);
            dispatch(setIsEditingDate({ isEditingDate: true }));
        }
    }, [deliveryDates, isEditingDates, dispatch]);

    // Clear any pending confirmation timers when this cart line unmounts.
    useEffect(() => {
        return () => {
            clearTimeout(copiedTimeoutRef.current);
            clearTimeout(pastedTimeoutRef.current);
        };
    }, []);

    if (!deliveryDates || !cartLine) {
        return null;
    }

    const removeErrorIfAny = () => {
        const _datesHasError = deliveryDates.some(
            d => d.error && (d.error.quantity || d.error.requestedDate || d.error.po),
        );

        if (!_datesHasError) {
            return;
        }

        const cleanedDeliveryDates = deliveryDates.map(d => ({
            ...d,
            error: undefined,
        }));

        setDeliveryDates(cleanedDeliveryDates);
    };

    const toggleDatesClickHandler = () => {
        setShowDatesTable(!showDatesTable);
    };

    const enableEditModeHandler = () => {
        setIsEditingDates(true);
        setSavedDeliveryDates(deliveryDates);
        dispatch(setIsEditingDate({ isEditingDate: true }));
    };

    const saveModificationsHandler = () => {
        removeErrorIfAny();

        const { validated, hasError } = validateRequestedDate(deliveryDates);

        setDeliveryDates(validated);

        if (hasError) {
            return;
        }

        setIsEditingDates(false);
        deliveryDatesUpdatedHandler(validated);
        dispatch(setIsEditingDate({ isEditingDate: false }));
    };

    const validateRequestedDate = (deliveryDates: CartLinesDeliveryDate[]) => {
        let hasError = false;

        const validated = deliveryDates.map(d => {
            const error: CartLinesDeliveryDate["error"] = {};

            // QTY validation
            if (!d.quantity || Number(d.quantity) <= 0) {
                error.quantity = `${translate("Please enter a valid quantity.")} ${translate(
                    "Any unneeded rows can be removed with the trashcan button",
                )}`;
                hasError = true;
            }

            // Date validation
            if (!d.requestedDate) {
                error.requestedDate = translate("Please enter a valid Requested Date (mm/dd/yyyy).");
                hasError = true;
            } else if (getDaysDifference(new Date(d.requestedDate), today) < 0) {
                error.requestedDate = translate(
                    "{0} is no longer valid. Please define a new date.",
                    getLocalizedDateTime({ dateTime: new Date(d.requestedDate), language }),
                );
                hasError = true;
            }

            // PO validation
            if (!d.customerOrderPO || d.customerOrderPO.trim() === "") {
                error.po = translate("Please enter a valid Purchase Order Number.");
                hasError = true;
            }

            return { ...d, error };
        });

        return { validated, hasError };
    };

    const cancelModificationsHandler = () => {
        setIsEditingDates(!isEditingDates);
        dispatch(setIsEditingDate({ isEditingDate: false }));

        if (savedDeliveryDates) {
            setDeliveryDates(savedDeliveryDates);
        }
    };

    const deleteDateHandler = (id: string) => {
        const filteredDates = deliveryDates.filter(x => x.id !== id);
        setDeliveryDates(filteredDates);
    };

    const addDateHandler = () => {
        setDeliveryDates([
            ...deliveryDates,
            {
                id: uniqueId(),
                quantity: 1,
                requestedDate: undefined,
                notes: "",
                customerOrderPO: "",
            },
        ]);
    };

    const deliveryDateChangeHandler = (selectedDay: Date | undefined, id: string) => {
        if (!selectedDay) {
            // Persist the cleared date to state so it matches the emptied field. Otherwise the row keeps its
            // previous date internally, and Copy captures that stale date instead of an empty one.
            setDeliveryDates(prev =>
                prev.map(d => (d.id === id ? { ...d, requestedDate: undefined, error: undefined } : d)),
            );
            return;
        }

        const dateIsValid = getDaysDifference(new Date(selectedDay), today) >= 0;

        const normalizedDate = new Date(
            selectedDay?.getFullYear(),
            selectedDay?.getMonth(),
            selectedDay?.getDate(),
            0,
            0,
            0,
        );

        if (dateIsValid) {
            const _tempDeliveryDates = deliveryDates.map(d =>
                d.id === id ? { ...d, requestedDate: normalizedDate, error: undefined } : d,
            );
            setDeliveryDates(_tempDeliveryDates);
        }
    };

    const qtyOrderedByDateChangeHandler = (quantity: number, id: string) => {
        const _tempDeliveryDates = deliveryDates.map(d => (d.id === id ? { ...d, quantity } : d));
        setDeliveryDates(_tempDeliveryDates);
    };

    const poChangeHandler = (po: string, id: string) => {
        const _tempDeliveryDates = deliveryDates.map(d => (d.id === id ? { ...d, customerOrderPO: po } : d));
        setDeliveryDates(_tempDeliveryDates);
    };

    const copyRowHandler = (row: CartLinesDeliveryDate) => {
        dispatch(
            setCopiedRequestedDateRow({
                copiedRow: {
                    quantity: row.quantity,
                    requestedDate: row.requestedDate,
                    customerOrderPO: row.customerOrderPO,
                },
            }),
        );

        clearTimeout(copiedTimeoutRef.current);
        setCopiedIndicatorId(row.id);
        copiedTimeoutRef.current = setTimeout(
            () => setCopiedIndicatorId(undefined),
            COPY_PASTE_CONFIRMATION_DURATION_MS,
        );
    };

    const pasteRowHandler = (id: string) => {
        if (!copiedRow) {
            return;
        }

        // Remount the target row's DatePicker so it re-reads the pasted value (notably an empty date, which the
        // picker won't clear from a prop change alone).
        datePasteVersionRef.current[id] = (datePasteVersionRef.current[id] ?? 0) + 1;

        // Overwrite the target row's three copyable values verbatim (including empties) as unsaved changes; clear any
        // stale per-row error so the pasted values are re-validated on Save, like manually entered values. notes/id
        // are preserved. Use a functional update so rapid successive pastes always apply to the latest rows.
        setDeliveryDates(prev =>
            prev.map(d =>
                d.id === id
                    ? {
                          ...d,
                          quantity: copiedRow.quantity,
                          requestedDate: copiedRow.requestedDate,
                          customerOrderPO: copiedRow.customerOrderPO,
                          error: undefined,
                      }
                    : d,
            ),
        );

        clearTimeout(pastedTimeoutRef.current);
        setPastedIndicatorId(id);
        pastedTimeoutRef.current = setTimeout(
            () => setPastedIndicatorId(undefined),
            COPY_PASTE_CONFIRMATION_DURATION_MS,
        );
    };

    const showActions = isEditingDates && deliveryDates.length > 1;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link
                {...(showDatesTable ? styles.collapseLink : styles.expandLink)}
                aria-expanded={showDatesTable}
                onClick={toggleDatesClickHandler}
                data-test-selector="cartline_datessShowHideButton"
            >
                {translate(showDatesTable ? "Hide Requested Dates" : "Show Requested Dates")}
            </Link>
            {showDatesTable && (
                <StyledWrapper {...styles.innerWrapper}>
                    {!isEditingDates && !isProductLine && (
                        <Link
                            {...styles.linkEdit}
                            onClick={enableEditModeHandler}
                            title={translate("Manage dates and quantities")}
                            data-test-selector="edit_cartLine_edit"
                        >
                            {translate("Edit")}
                        </Link>
                    )}
                    <StyledWrapper {...styles.tableWrapper}>
                        <DataTable {...styles.dataTable}>
                            <DataTableHead>
                                <DataTableHeader
                                    {...styles.quantityTableHeader}
                                    data-test-selector="edit_cartLine_qty_header"
                                >
                                    <StyledWrapper {...styles.tableHeaderWrapper}>
                                        {translate("QTY")}
                                        {cartLine.pricing?.additionalResults?.fullTruckLoad && !isProductLine && (
                                            <ProductFullTruckLoad
                                                {...styles.productFullTruckLoad}
                                                overrideFtl={{
                                                    ftlQuantity: cartLine.pricing?.additionalResults?.fullTruckLoad,
                                                    plant: cartLine.pricing?.additionalResults?.warehouseName,
                                                }}
                                            />
                                        )}
                                    </StyledWrapper>
                                </DataTableHeader>
                                <DataTableHeader
                                    {...styles.dateTableHeader}
                                    data-test-selector="edit_cartLine_requested_date_header"
                                >
                                    <StyledWrapper {...styles.tableHeaderWrapper}>
                                        {translate("Requested Delivery Date")}
                                        {cartLine.pricing?.additionalResults?.leadTime && !isProductLine && (
                                            <ProductLeadTime
                                                {...styles.productLeadTime}
                                                overrideLT={{
                                                    isSpecialItem:
                                                        cartLine.pricing?.additionalResults?.isSpecialItem === "True",
                                                    plant: cartLine.pricing?.additionalResults?.warehouseName,
                                                    leadTimeDays: Number(cartLine.pricing?.additionalResults?.leadTime),
                                                    minimumOrderQuantity: Number(
                                                        cartLine.pricing?.additionalResults?.minimumOrderQuantity,
                                                    ),
                                                }}
                                            />
                                        )}
                                    </StyledWrapper>
                                </DataTableHeader>
                                <DataTableHeader {...styles.poTableHeader} data-test-selector="edit_cartLine_po_header">
                                    {translate("PO #")}
                                </DataTableHeader>
                                {showActions && <DataTableHeader {...styles.actionsTableHeader}></DataTableHeader>}
                            </DataTableHead>
                            <DataTableBody>
                                {deliveryDates.map((date, index) => {
                                    const errors = Object.values(date.error ?? {}).filter(Boolean);
                                    const showErrors = errors.length > 0;
                                    const isBelowMoq =
                                        minimumOrderQuantity > 0 &&
                                        Number(date.quantity) > 0 &&
                                        Number(date.quantity) < minimumOrderQuantity;
                                    const rowClassName =
                                        [
                                            showErrors && "error",
                                            isBelowMoq && "below-moq",
                                            enableCopyPaste && isEditingDates && "has-actions",
                                        ]
                                            .filter(Boolean)
                                            .join(" ") || undefined;

                                    return (
                                        <Fragment key={index}>
                                            <DataTableRow className={rowClassName}>
                                                <DataTableCell
                                                    {...styles.quantityTableCell}
                                                    data-test-selector={`edit_cartLine_qty_cell`}
                                                >
                                                    {isProductLine || !cart ? (
                                                        <ProductLineQuantity
                                                            {...(isBelowMoq ? styles.belowMoqProductLineQuantity : {})}
                                                            canEdit={isEditingDates}
                                                            label=""
                                                            quantity={Number(date.quantity)}
                                                            onChange={quantity =>
                                                                qtyOrderedByDateChangeHandler(quantity, date.id)
                                                            }
                                                        />
                                                    ) : (
                                                        <CartLineQuantity
                                                            {...(isBelowMoq ? styles.belowMoqCartLineQuantity : {})}
                                                            cart={cart}
                                                            editable={isEditingDates}
                                                            noLabel
                                                            overridedQty={Number(date.quantity)}
                                                            onQtyOrderedChange={quantity =>
                                                                qtyOrderedByDateChangeHandler(quantity, date.id)
                                                            }
                                                        />
                                                    )}
                                                </DataTableCell>
                                                <DataTableCell
                                                    {...styles.dateTableCell}
                                                    data-test-selector={`edit_cartLine_requested_date_cell`}
                                                >
                                                    {isEditingDates ? (
                                                        <DatePicker
                                                            key={`requested-date-${date.id}-${
                                                                datePasteVersionRef.current[date.id] ?? 0
                                                            }`}
                                                            {...styles.datePicker}
                                                            selectedDay={
                                                                typeof date.requestedDate === "string"
                                                                    ? new Date(date.requestedDate)
                                                                    : date.requestedDate
                                                            }
                                                            dateTimePickerProps={{
                                                                minDate: today,
                                                                maxDate: addDays(
                                                                    new Date(),
                                                                    cartSettings.maximumDeliveryPeriod,
                                                                ),
                                                            }}
                                                            onDayChange={({
                                                                selectedDay,
                                                            }: Pick<DatePickerState, "selectedDay">) =>
                                                                deliveryDateChangeHandler(selectedDay, date.id)
                                                            }
                                                        />
                                                    ) : date.requestedDate ? (
                                                        <LocalizedDateTime dateTime={date.requestedDate} />
                                                    ) : (
                                                        <Status {...styles.status}>
                                                            {translate("Please define date")}
                                                        </Status>
                                                    )}
                                                </DataTableCell>
                                                <DataTableCell
                                                    {...styles.poTableCell}
                                                    data-test-selector={`edit_cartLine_po_cell`}
                                                >
                                                    {isEditingDates ? (
                                                        <TextField
                                                            {...styles.poTextField}
                                                            type="text"
                                                            value={date.customerOrderPO}
                                                            onChange={e => poChangeHandler(e.target.value, date.id)}
                                                        />
                                                    ) : date.customerOrderPO ? (
                                                        <Typography>{date.customerOrderPO}</Typography>
                                                    ) : (
                                                        <Status {...styles.status}>
                                                            {translate("Please fill PO#")}
                                                        </Status>
                                                    )}
                                                </DataTableCell>
                                                {showActions && (
                                                    <DataTableCell
                                                        {...styles.actionsTableCell}
                                                        data-test-selector={`edit_cartLine_actions_cell`}
                                                    >
                                                        <Link
                                                            {...styles.linkDelete}
                                                            onClick={() => deleteDateHandler(date.id)}
                                                            title={translate("Delete requested date row.")}
                                                        />
                                                    </DataTableCell>
                                                )}
                                            </DataTableRow>
                                            {enableCopyPaste && isEditingDates && (
                                                <DataTableRow
                                                    className={showErrors || isBelowMoq ? "has-messages" : undefined}
                                                >
                                                    <DataTableCell
                                                        {...styles.copyPasteTableCell}
                                                        colSpan={showActions ? 4 : 3}
                                                        data-test-selector="edit_cartLine_copyPaste_cell"
                                                    >
                                                        <StyledWrapper {...styles.copyPasteWrapper}>
                                                            {copiedIndicatorId === date.id ? (
                                                                <StyledWrapper
                                                                    {...styles.copyPasteConfirmation}
                                                                    data-test-selector="edit_cartLine_copied"
                                                                >
                                                                    <Icon {...styles.confirmationIcon} />
                                                                    {translate("Copied")}
                                                                </StyledWrapper>
                                                            ) : (
                                                                <Link
                                                                    {...styles.linkCopy}
                                                                    onClick={() => copyRowHandler(date)}
                                                                    data-test-selector="edit_cartLine_copy"
                                                                >
                                                                    {translate("Copy")}
                                                                </Link>
                                                            )}
                                                            {pastedIndicatorId === date.id ? (
                                                                <StyledWrapper
                                                                    {...styles.copyPasteConfirmation}
                                                                    data-test-selector="edit_cartLine_pasted"
                                                                >
                                                                    <Icon {...styles.confirmationIcon} />
                                                                    {translate("Pasted")}
                                                                </StyledWrapper>
                                                            ) : (
                                                                <Link
                                                                    {...(copiedRow
                                                                        ? styles.linkPaste
                                                                        : styles.linkPasteDisabled)}
                                                                    disabled={!copiedRow}
                                                                    onClick={() => pasteRowHandler(date.id)}
                                                                    data-test-selector="edit_cartLine_paste"
                                                                >
                                                                    {translate("Paste")}
                                                                </Link>
                                                            )}
                                                        </StyledWrapper>
                                                    </DataTableCell>
                                                </DataTableRow>
                                            )}
                                            {showErrors && (
                                                <DataTableRow>
                                                    <DataTableCell
                                                        {...styles.errorTableCell}
                                                        colSpan={showActions ? 4 : 3}
                                                        data-test-selector={`edit_cartLine_error_cell`}
                                                    >
                                                        <InfosBox type="error" size="small">
                                                            {errors.length > 1
                                                                ? `${translate(
                                                                      "Please completely fill out all fields.",
                                                                  )} ${translate(
                                                                      "Any unneeded rows can be removed with the trashcan button",
                                                                  )}`
                                                                : errors[0]}
                                                        </InfosBox>
                                                    </DataTableCell>
                                                </DataTableRow>
                                            )}
                                            {isBelowMoq && (
                                                <DataTableRow>
                                                    <DataTableCell
                                                        {...styles.belowMoqTableCell}
                                                        colSpan={showActions ? 4 : 3}
                                                        data-test-selector={`edit_cartLine_belowMoq_cell`}
                                                    >
                                                        <InfosBox {...styles.belowMoqInfosBox}>
                                                            {siteMessage("Cart.BelowMoqAlert")}
                                                        </InfosBox>
                                                    </DataTableCell>
                                                </DataTableRow>
                                            )}
                                        </Fragment>
                                    );
                                })}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                    {isEditingDates && (
                        <StyledWrapper {...styles.actionsWrapper}>
                            <StyledWrapper {...styles.leftActionsWrapper}>
                                <Link
                                    {...styles.linkAdd}
                                    onClick={addDateHandler}
                                    data-test-selector="edit_cartLine_addRequestedDate"
                                >
                                    {translate("Add a requested date")}
                                </Link>
                            </StyledWrapper>
                            <StyledWrapper {...styles.rightActionsWrapper}>
                                <Button
                                    {...styles.buttonCancel}
                                    onClick={cancelModificationsHandler}
                                    title={translate("Cancel changes")}
                                    disabled={!savedDeliveryDates.length}
                                    data-test-selector="edit_cartLine_cancel"
                                >
                                    {translate("Cancel")}
                                </Button>
                                <Button
                                    {...styles.buttonSave}
                                    onClick={saveModificationsHandler}
                                    title={translate("Apply changes")}
                                    data-test-selector="edit_cartLine_save"
                                >
                                    {translate("Save")}
                                </Button>
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                    {!isEditingDates && isProductLine && (
                        <StyledWrapper {...styles.actionsWrapper}>
                            <StyledWrapper {...styles.rightActionsWrapper}>
                                <Button
                                    {...styles.buttonEdit}
                                    onClick={enableEditModeHandler}
                                    title={translate("Manage dates and quantities")}
                                    data-test-selector="edit_cartLine_edit"
                                >
                                    {translate("Edit")}
                                </Button>
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default CartLinesDates;
